/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationSourcesControllerFindAllQueryResponse, ApplicationSourcesControllerFindAllQueryParams, ApplicationSourcesControllerFindAll401, ApplicationSourcesControllerFindAll403 } from "../../models/checklistsController/ApplicationSourcesControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { applicationSourcesControllerFindAll } from "../../clients/checklistsService/applicationSourcesControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const applicationSourcesControllerFindAllQueryKey = (params: ApplicationSourcesControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/checklist-application-sources'
}, ...(params ? [params] : [])] as const;
export type ApplicationSourcesControllerFindAllQueryKey = ReturnType<typeof applicationSourcesControllerFindAllQueryKey>;
export function applicationSourcesControllerFindAllQueryOptions(params?: ApplicationSourcesControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = applicationSourcesControllerFindAllQueryKey(params);
  return queryOptions<ApplicationSourcesControllerFindAllQueryResponse, ResponseErrorConfig<ApplicationSourcesControllerFindAll401 | ApplicationSourcesControllerFindAll403>, ApplicationSourcesControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return applicationSourcesControllerFindAll(params, config);
    }
  });
}

/**
 * @description This endpoint supports a higher page size limit of 1000 (default is 100). Use `page[size]=1000` to retrieve up to 1000 records per request.
 * @summary Get all checklist application sources
 * {@link /api/v1/checklist-application-sources}
 */
export function useApplicationSourcesControllerFindAll<TData = ApplicationSourcesControllerFindAllQueryResponse, TQueryData = ApplicationSourcesControllerFindAllQueryResponse, TQueryKey extends QueryKey = ApplicationSourcesControllerFindAllQueryKey>(params?: ApplicationSourcesControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<ApplicationSourcesControllerFindAllQueryResponse, ResponseErrorConfig<ApplicationSourcesControllerFindAll401 | ApplicationSourcesControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? applicationSourcesControllerFindAllQueryKey(params);
  const query = useQuery({
    ...applicationSourcesControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ApplicationSourcesControllerFindAll401 | ApplicationSourcesControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}